export default "__VITE_ASSET__Q7X3Bu3G__"